import styled from 'styled-components';

import {
  typography,
  layout,
} from '../../theme';


export const Wrapper = styled.div`
  margin-top: ${160 / typography.BASE_FONT_SIZE}rem;
  overflow: hidden;
  position: relative;
  width: 100%;
  display: inline-block;
  padding-top: ${3 / typography.BASE_FONT_SIZE}rem;

  @media all and (max-width: 1023px) and (min-width: 667px) {
    margin-top: ${70 / typography.BASE_FONT_SIZE}rem;
  }
  @media screen and (max-width: 666px) {
    margin-top: ${80 / typography.BASE_FONT_SIZE}rem;
  }
`;

export const SliderPadding = styled.div`
  overflow: visible;
  padding: 0 ${layout.SECTION_MARGIN}rem;

  @media all and (max-width: 1023px) and (min-width: 667px) {
    padding: 0 ${layout.SECTION_PADDING / 2}rem;
  }

  @media screen and (max-width: 666px) {
    padding: 0 ${20/typography.BASE_FONT_SIZE}rem;
  }
`;

export const SliderWrapper = styled.div`
  cursor: pointer;
  display: flex;
  height: ${384 / typography.BASE_FONT_SIZE}rem;
  overflow: visible;
`;

export const Slider = styled.div`
  cursor: grab;
  display: flex;

  &.dragging {
    cursor: grabbing;
  }
`;

export const SliderItem = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  margin: 0 0.5rem 0 0;
  width: auto;

  &:last-child {
    margin-right: 0;
  }
`;

export const ZoomedItems = styled.div`
`;

export const ZoomCloseButton = styled.div`
  bottom: 0;
  cursor: zoom-out;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9999;
`;



// WEBPACK FOOTER //
// ./src/components/ScrollingList/style.js